export const social = [
  { id: 1, url: "/facebook", name: "fb" },
  { id: 2, url: "/instagram", name: "ig" },
  { id: 3, url: "/youtube", name: "yt" },
  { id: 4, url: "/lk", name: "lk" },
];
